(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cuddle-newpal-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const box = document.querySelector('[data-cuddle-pal]');
    if (!box || typeof box.showModal !== 'function') return;
    const get = (store, key) => { try { return store.getItem(key); } catch (e) { return null; } };
    const set = (store, key) => { try { store.setItem(key, '1'); } catch (e) {} };
    if (get(localStorage, 'cuddle-pal-never') || get(sessionStorage, 'cuddle-pal-seen')) return;

    const never = box.querySelector('[data-cuddle-pal-never]');
    box.addEventListener('close', () => {
      set(sessionStorage, 'cuddle-pal-seen');
      if (never.checked) set(localStorage, 'cuddle-pal-never');
    });
    box.querySelector('[data-cuddle-pal-close]').addEventListener('click', () => box.close());
    box.addEventListener('click', (event) => { if (event.target === box) box.close(); });
    box.querySelector('.cuddle-pal__btn').addEventListener('click', () => box.close());

    let shown = false;
    const open = () => {
      if (shown || get(sessionStorage, 'cuddle-pal-seen')) return;
      if (document.querySelector('dialog[open]')) return;
      shown = true;
      box.showModal();
    };

    if (box.dataset.mode === 'shop') {
      setTimeout(open, 6000);
      return;
    }

    /* Home: wait until the shop part of the page is on screen, so the community comes first. */
    const target = document.getElementById('cuddle-story');
    if (target && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { io.disconnect(); setTimeout(open, 1500); }
      }, { threshold: 0.25 });
      io.observe(target);
    }
    setTimeout(open, 45000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
